<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-chalkboard-user"></i></div>
      <div>
        Liste des professeurs
        <div class="page-title-subheading">Enseignants de l'établissement</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
   <div class="row">
    <div class="col-lg-12">
        <div class="card">
          
            <div class="card-body">
             
                <div class="d-flex justify-content-between mb-5">
                    <div class="me-2">
                        <button *ngIf="buttonsPermission?.add" type="button" class="btn btn-danger btn-sm" (click)="add(addContent)">
                            <i class="fa-solid fa-plus me-2" aria-hidden="true"></i>Nouvel enseignant
                            </button>
                    </div>
                    <div class=" " *ngIf="buttonsPermission">
                        <button *ngIf="selected_data && buttonsPermission.show"  (click)="show(showContent)" type="button" class="btn btn-outline-primary btn-sm btn-label waves-effect waves-light me-3">
                             <span>Consulter</span></button>
                        <button *ngIf="selected_data && buttonsPermission.edit" (click)="edit(editContent)" type="button"  class="btn btn-outline-warning btn-sm btn-label waves-effect waves-light me-3">
                           Editer</button>
                        <button *ngIf="selected_data && buttonsPermission.delete" (click)="delete()" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                             Supprimer</button>
                             <button *ngIf="selected_data && is_active!=null && !is_active" (click)="setStatus(1)" type="button" class="btn btn-outline-success btn-sm btn-label waves-effect waves-light me-3">
                                Activer</button>
                               <button  *ngIf="selected_data && is_active!=null && is_active" (click)="setStatus(0)" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                                Désactiver</button>
                                <button class="btn btn-info btn-sm btn-label waves-effect waves-light me-3" (click)="addFileContent(PjContent)">Ajouter des compétences</button>
                                <button *ngIf="data.length!=0" (click)="getPdf()" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                                    Exporter en PDF</button>
                    </div>

                    <div class="form-group ms-auto">
                        <label for=""> <strong>Rechercher:</strong> </label>
                        <input placeholder="Rechercher..." class="form-control form-control-sm" type="text" name="search_text" [(ngModel)]="search_text">
                    </div>
                </div>

                        <p>{{data!.length}} élément(s)</p>
                        <div class="table-responsive">
                        <table class="table" >
                            <thead class="">
                                <tr>
                                    <th style="width: 10px;">#</th>
                                    <th>Code</th>
                                    <th>Nom et prénom(s)</th>
                                    <th>Email</th>
                                    <th>Contact</th>
                                    <th>Document</th>
                                    <th>Statut</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data | sampleSearch:search_text:'professors' | paginate: {
                                id:'ngxP1',
                                itemsPerPage: pg.pageSize,
                                currentPage: pg.p,
                                totalItems: pg.total } ">
                                    <td>
                                        <div class="form-check mb-2">
                                            <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                                        
                                        </div>
                                    </td>
                                    <td>{{d.code}}</td>
                                    <td>{{d.lastname}} {{d.firstname}}</td>
                                    <td>{{d.email}}</td>
                                    <td>{{d.phone}}</td>
                                    <td>
                                        <ul>
                                            <li *ngFor="let f of d.files">
                                                <span *ngIf="f.filename!=null" style="cursor: pointer;" (click)="getFile(d.code,'professors',f.filename)"><u class="text-primary">{{f.name}}</u></span>
                                                <span *ngIf="f.filename==null" style="cursor: pointer;" ><u class="text-primary">{{f.name}}</u></span>
                                                <i class="fa fa-times text-danger pointer ms-1" (click)="removeFile(f.id)"></i>
                                            </li>
                                        </ul>
                                    </td>
                                    <td>
                                        <span *ngIf="d.is_active" class="badge bg-success">Actif</span>
                                        <span *ngIf="!d.is_active" class="badge bg-danger">Bloqué</span>

                                    </td>
                                </tr>
                            
                            </tbody>
                        </table>
                        </div>
                          <pagination-controls 
                        id="ngxP1"
                        (pageChange)="getPage($event)"
                      [maxSize]="9"
                      [directionLinks]="true"
                      [autoHide]="true"
                      [responsive]="true"
                      [previousLabel]="'Précédent'"
                      [nextLabel]="'Suivant'"
                      [screenReaderPaginationLabel]="'Pagination'"
                      [screenReaderPageLabel]="'page'"
                      [screenReaderCurrentLabel]="'Vous êtes sur la page'">
                     </pagination-controls>

            </div><!-- end card -->
        </div>
        <!-- end col -->
    </div>
    <!-- end col -->
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Enregistrer un enseignant</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Nom <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="lastname" class="form-control" ngModel>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Prénoms <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="firstname" class="form-control" ngModel>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Date de naissance <span class="text-danger ml-2">(*)</span></label>
                <input type="date" name="birthdate" class="form-control" ngModel>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Lieu de naissance  <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="birthplace" class="form-control" ngModel>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Email <span class="text-danger ml-2">(*)</span></label>
                <input type="email" name="email" class="form-control" ngModel>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Contact <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="phone" class="form-control" ngModel>
            </div>
         
            <div class=" form-group col-12 mb-3">
                <label for="">Cycles</label>
                <ng-select [multiple]="true" [(ngModel)]="selectedCycles" name="selectedCycles">
                    <ng-option *ngFor="let c of cycles" [value]="c.id">{{c.name}}</ng-option>
                 </ng-select>
             </div>
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #editContent let-c="close" let-d="dismiss">
    <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Modifier les données d'un enseignant</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3">
        
            <div class=" form-group col-12 mb-3">
                <label for="">Nom <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="lastname" class="form-control" [(ngModel)]="selected_data.lastname">
            </div> 
            <div class=" form-group col-12 mb-3">
                <label for="">Prénoms <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="firstname" class="form-control" [(ngModel)]="selected_data.firstname">
            </div> 
            <div class=" form-group col-12 mb-3">
                <label for="">Date de naissance <span class="text-danger ml-2">(*)</span></label>
                <input type="date" name="birthdate" class="form-control" [(ngModel)]="selected_data.birthdate">
            </div> 
            <div class=" form-group col-12 mb-3">
                <label for="">Lieu de naissance <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="birthplace" class="form-control" [(ngModel)]="selected_data.birthplace">
            </div> 
            <div class=" form-group col-12 mb-3">
                <label for="">Email <span class="text-danger ml-2">(*)</span></label>
                <input type="email" name="email" class="form-control" [(ngModel)]="selected_data.email">
            </div> 
          
            <div class=" form-group col-12 mb-3">
                <label for="">Contact <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="phone" class="form-control" [(ngModel)]="selected_data.phone">
            </div> 
            <div class=" form-group col-12 mb-3">
                <label for="">Cycles</label>
                <ng-select [multiple]="true" [(ngModel)]="selectedCycles" name="selectedCycles">
                    <ng-option *ngFor="let c of cycles" [value]="c.id">{{c.name}}</ng-option>
                 </ng-select>
             </div>
          
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="editForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #showContent let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Détails des informations</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
      </div>

      <div class="modal-body">
        <div class="table-responsive table-card">
            <table class="table table-borderless align-middle mb-0">
                <tbody>
                 
                </tbody>
            </table>
        </div>
      </div>
</ng-template>
  <ng-template #PjContent let-c="close" let-d="dismiss">
      
        <div class="modal-header">
          <h6 class="modal-title" id="modal-basic-title">Ajout de pièce</h6>
          <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body" >
            <form #editForm="ngForm" (ngSubmit)="addElement(editForm)">
            <div class="row mb-3">
        
                <div class="form-group col-12 mb-3">
                    <label for="">Choisir une compétence</label>
                    <ng-select name="name" [(ngModel)]="name">
                        <ng-option *ngFor="let sk of skills" [value]="sk">{{sk}}</ng-option>
                    </ng-select>
                </div>
                <div *ngIf="name=='Autre'" class=" form-group col-12 mb-3">
                    <label for="">Saisissez la compétence <span class="text-danger ml-2">(*)</span></label>
                    <input type="text" name="other_name" class="form-control" ngModel>
                </div> 
                <div class=" form-group col-12 mb-3">
                    <label for="">Charger la pièce <span class="text-danger ml-2">(*)</span></label>
                    <input type="file" class="form-control" (change)="upload($event)" accept=".pdf">
                </div> 
            </div>
            <div class="text-center">
                <button class="btn btn-sm btn-primary" type="submit" [disabled]="loading">Ajouter une compétence</button>
            </div>
        </form>
            <hr>
            <table class="table table-sm">
                <thead>
                    <th>#</th>
                    <th>Compétence</th>
                    <th>Action</th>
                </thead>
                <tbody>
                    <tr *ngFor="let f of pjs; let i=index">
                        <td>{{i+1}}</td>
                        <td>{{f.name}}</td>
                        <td>
                            <button (click)="removeItem(i)" class="btn-sm btn-danger btn">
                                <i class="fa fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
    </div>
    <div class="modal-footer">
      <button type="button" (click)="addFile()" class="btn btn-outline-dark" [disabled]="editForm.invalid || loading" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
    </div>

</ng-template>
<ng-template #contentPDF let-offcanvas>
	<div class="offcanvas-header">
    
		<h4 class="offcanvas-title">Visualiseur de fichier</h4>
		<button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
	</div>
	<div class="offcanvas-body">
        <ngx-extended-pdf-viewer [src]="pdfSrc"
        style="width: 100%; height: 100%"
        ></ngx-extended-pdf-viewer>
	</div>
</ng-template>

